/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AttachmentCreateRequest,
  AttachmentResponse,
  AttachmentUpdateRequest,
  BidCreateRequest,
  BidDeleteRequest,
  Body,
  CreateCommentRequest,
  FeeCreateRequest,
  FeeUpdateRequest,
  FindUsersRequest,
  FixedPriceOfferAcceptOfferRequest,
  FixedPriceOfferBuyNowRequest,
  FixedPriceOfferRejectOfferRequest,
  ItemCreateRequest,
  ItemUpdateRequest,
  ListingCreateRequest,
  ListingUpdatePropertiesRequest,
  ListingUpdateRequest,
  OfferCreateRequest,
  PaymentMethodRequest,
  ProblemDetails,
  ProductClassCreateRequest,
  ProductClassUpdateRequest,
  TenantUserAssignRoleRequest,
  WithdrawListingRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Attachment
   * @name AttachmentGetDirectUploadUrl
   * @summary Get url for attachment direct upload.
   * @request GET:/api/v1/attachment/direct-upload
   * @secure
   * @response `200` `object`
   */
  attachmentGetDirectUploadUrl = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/attachment/direct-upload`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Attachment
   * @name AttachmentGetDirectUploadImageStatus
   * @summary Get image status uploaded using direct upload url.
   * @request GET:/api/v1/attachment/direct-upload/{imageId}
   * @secure
   * @response `200` `object`
   */
  attachmentGetDirectUploadImageStatus = <T,>(imageId: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/attachment/direct-upload/${imageId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Attachment
   * @name AttachmentGetBatchDirectUploadUrl
   * @summary Get url for attachment batch direct upload.
   * @request GET:/api/v1/attachment/batch-direct-upload
   * @secure
   * @response `200` `object`
   */
  attachmentGetBatchDirectUploadUrl = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/attachment/batch-direct-upload`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Attachment
   * @name AttachmentFindAll
   * @summary Get item attachments details
   * @request GET:/api/v1/item/{itemId}/attachment
   * @response `200` `object`
   */
  attachmentFindAll = <T,>(
    itemId: string,
    query: {
      /** include deleted/inactive to the response or not */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/item/${itemId}/attachment`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Attachment
   * @name AttachmentCreate
   * @summary Create an attachment record.
   * @request POST:/api/v1/item/{itemId}/attachment
   * @secure
   * @response `200` `object`
   */
  attachmentCreate = <T,>(itemId: string, data: AttachmentCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/item/${itemId}/attachment`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Attachment
   * @name AttachmentUpdate
   * @summary Update attachment's sort order and category.
   * @request PUT:/api/v1/item/{itemId}/attachment/{id}
   * @secure
   * @response `200` `(AttachmentResponse)[]` Success
   */
  attachmentUpdate = (itemId: string, id: string, data: AttachmentUpdateRequest, params: RequestParams = {}) =>
    this.request<AttachmentResponse[], any>({
      path: `/api/v1/item/${itemId}/attachment/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Attachment
   * @name AttachmentDelete
   * @summary Delete an attachment.
   * @request DELETE:/api/v1/item/{itemId}/attachment/{id}
   * @secure
   * @response `200` `File` Success
   */
  attachmentDelete = (itemId: string, id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/item/${itemId}/attachment/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Bids
   * @name BidsFindAllForAdmin
   * @summary Get all bids for Admin for a listing in any status.
   * @request GET:/api/v1/admin/auction/{listingId}/bid
   * @secure
   * @response `200` `object`
   */
  bidsFindAllForAdmin = <T,>(
    listingId: string,
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/auction/${listingId}/bid`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bids
   * @name BidsFindAll
   * @summary Get all bids for live auction.
   * @request GET:/api/v1/auction/{listingId}/bid
   * @response `200` `object`
   */
  bidsFindAll = <T,>(listingId: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/auction/${listingId}/bid`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bids
   * @name BidsCreate
   * @summary Create a new **bid**
   * @request POST:/api/v1/auction/{listingId}/bid
   * @secure
   * @response `200` `object`
   */
  bidsCreate = <T,>(listingId: string, data: BidCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/auction/${listingId}/bid`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bids
   * @name BidsDelete
   * @summary Delete an existing bid
   * @request DELETE:/api/v1/auction/{listingId}/bid/{id}
   * @secure
   * @response `200` `File` Success
   */
  bidsDelete = (listingId: string, id: string, data: BidDeleteRequest, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/auction/${listingId}/bid/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Comment
   * @name CommentFindAll
   * @summary Get all comments and responses for a listing
   * @request GET:/api/v1/listings/{listingId}/comments
   * @response `200` `object`
   */
  commentFindAll = <T,>(
    listingId: string,
    query: {
      /** include deleted/inactive to the response or not */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/listings/${listingId}/comments`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Comment
   * @name CommentCreate
   * @summary Create a new comment for a listing
   * @request POST:/api/v1/listings/{listingId}/comments
   * @secure
   * @response `200` `object`
   */
  commentCreate = <T,>(listingId: string, data: CreateCommentRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/listings/${listingId}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Comment
   * @name CommentDelete
   * @summary Delete an existing active comment for a tenant's listing
   * @request DELETE:/api/v1/listings/{listingId}/comments/{id}
   * @secure
   * @response `200` `File` Success
   */
  commentDelete = (listingId: string, id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/listings/${listingId}/comments/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyGetByCode
   * @summary Get currency details
   * @request GET:/api/v1/currency/{code}
   * @response `200` `object`
   */
  currencyGetByCode = <T,>(
    code: string,
    query: {
      /** include deleted/inactive to the response or not */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/currency/${code}`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyFindAll
   * @summary Get all the currencies
   * @request GET:/api/v1/currency
   * @response `200` `object`
   */
  currencyFindAll = <T,>(
    query: {
      /** include deleted/inactive to the response or not */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/currency`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Fee
   * @name FeeGetById
   * @summary Get fee details
   * @request GET:/api/v1/fee/{id}
   * @secure
   * @response `200` `object`
   */
  feeGetById = <T,>(
    id: string,
    query: {
      /** include deleted/inactive to the response or not */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/fee/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Fee
   * @name FeeUpdate
   * @summary Update an existing active fee
   * @request PUT:/api/v1/fee/{id}
   * @secure
   * @response `204` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  feeUpdate = (id: string, data: FeeUpdateRequest, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/fee/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Fee
   * @name FeeDelete
   * @summary Delete an existing active fee for a tenant
   * @request DELETE:/api/v1/fee/{id}
   * @secure
   * @response `200` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  feeDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/fee/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Fee
   * @name FeeFindAll
   * @summary Get all the fees for a tenant
   * @request GET:/api/v1/fee
   * @secure
   * @response `200` `object`
   */
  feeFindAll = <T,>(
    query: {
      /** include deleted/inactive to the response or not */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/fee`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Fee
   * @name FeeCreate
   * @summary Create a new fee for a tenant
   * @request POST:/api/v1/fee
   * @secure
   * @response `200` `object`
   */
  feeCreate = <T,>(data: FeeCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/fee`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferFindOffersForAdmin
   * @summary Get offers.
   * @request GET:/api/v1/admin/listing/{listingId}/offer
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferFindOffersForAdmin = <T,>(listingId: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/admin/listing/${listingId}/offer`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferFindOffers
   * @summary Get offers.
   * @request GET:/api/v1/listing/{listingId}/offer
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferFindOffers = <T,>(listingId: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/listing/${listingId}/offer`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferCreateOffer
   * @summary Create a new offer.
   * @request POST:/api/v1/listing/{listingId}/offer
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferCreateOffer = <T,>(listingId: string, data: OfferCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/listing/${listingId}/offer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferBuyNow
   * @summary Create a new 'buy now' offer.
   * @request POST:/api/v1/listing/{listingId}/buy-now
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferBuyNow = <T,>(listingId: string, data: FixedPriceOfferBuyNowRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/listing/${listingId}/buy-now`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferAcceptOffer
   * @summary Accept an offer.
   * @request POST:/api/v1/listing/{listingId}/offer/{offerId}/accept
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferAcceptOffer = <T,>(
    listingId: string,
    offerId: string,
    data: FixedPriceOfferAcceptOfferRequest,
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/listing/${listingId}/offer/${offerId}/accept`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferRejectOffer
   * @summary Reject an offer.
   * @request POST:/api/v1/listing/{listingId}/offer/{offerId}/reject
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferRejectOffer = <T,>(
    listingId: string,
    offerId: string,
    data: FixedPriceOfferRejectOfferRequest,
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/listing/${listingId}/offer/${offerId}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferCreateCounterOffer
   * @summary Make a counter-offer.
   * @request POST:/api/v1/listing/{listingId}/offer/{offerId}/counter-offer
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferCreateCounterOffer = <T,>(
    listingId: string,
    offerId: string,
    data: OfferCreateRequest,
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/listing/${listingId}/offer/${offerId}/counter-offer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FixedPriceOffer
   * @name FixedPriceOfferOfferRead
   * @summary Mark an offer as read/viewed.
   * @request POST:/api/v1/listing/{listingId}/offer/{offerId}/mark-as-read
   * @secure
   * @response `200` `object`
   */
  fixedPriceOfferOfferRead = <T,>(listingId: string, offerId: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/listing/${listingId}/offer/${offerId}/mark-as-read`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Heartbeat
   * @name HeartbeatGet
   * @summary Get current datetime from server
   * @request GET:/api/v1/heartbeat
   * @response `200` `object`
   */
  heartbeatGet = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/heartbeat`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemFindAllForAdmin
   * @summary Get a list of all the product items
   * @request GET:/api/v1/admin/item
   * @secure
   * @response `200` `object`
   */
  itemFindAllForAdmin = <T,>(
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
      /** item status - comma separate list of statuses (Draft, Proposal, Accepted, Rejected, Listed) */
      itemStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/item`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemGetForAdminById
   * @summary Get item for tenant.
   * @request GET:/api/v1/admin/item/{itemId}
   * @secure
   * @response `200` `object`
   */
  itemGetForAdminById = <T,>(
    itemId: string,
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/item/${itemId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemUpdateForAdmin
   * @summary Update an existing item in any status.
   * @request PUT:/api/v1/admin/item/{itemId}
   * @secure
   * @response `204` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  itemUpdateForAdmin = (itemId: string, data: ItemUpdateRequest, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/admin/item/${itemId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemAccept
   * @summary Accept an item. Can be done by Tenant Admin only.
   * @request PUT:/api/v1/admin/item/{itemId}/accept
   * @secure
   * @response `200` `File` Success
   */
  itemAccept = (itemId: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/item/${itemId}/accept`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemReject
   * @summary Reject an item. Can be done by Tenant Admin only.
   * @request PUT:/api/v1/admin/item/{itemId}/reject
   * @secure
   * @response `200` `File` Success
   */
  itemReject = (itemId: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/item/${itemId}/reject`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemDelete
   * @summary Remove an existing item
   * @request DELETE:/api/v1/seller/item/{itemId}
   * @secure
   * @response `200` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  itemDelete = (itemId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/seller/item/${itemId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemGetForSellerById
   * @summary Get item for tenant
   * @request GET:/api/v1/seller/item/{itemId}
   * @secure
   * @response `200` `object`
   */
  itemGetForSellerById = <T,>(itemId: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/seller/item/${itemId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemUpdateForSeller
   * @summary Update an existing item in Proposal status only.
   * @request PUT:/api/v1/seller/item/{itemId}
   * @secure
   * @response `204` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  itemUpdateForSeller = (itemId: string, data: ItemUpdateRequest, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/seller/item/${itemId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemCreateProposal
   * @summary Create a proposal from an item in Draft status.
   * @request PUT:/api/v1/seller/item/{itemId}/create-proposal
   * @secure
   * @response `201` `void` Success
   * @response `400` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  itemCreateProposal = (itemId: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/seller/item/${itemId}/create-proposal`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemFindAllForSeller
   * @summary Get a list of all the product items
   * @request GET:/api/v1/seller/item
   * @secure
   * @response `200` `object`
   */
  itemFindAllForSeller = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/seller/item`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Item
   * @name ItemCreateDraftOrProposal
   * @summary Create draft or proposal of an item
   * @request POST:/api/v1/seller/item
   * @secure
   * @response `200` `object`
   */
  itemCreateDraftOrProposal = <T,>(data: ItemCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/seller/item`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ItemStatusCount
   * @name ItemStatusCountFindAllForAdmin
   * @summary Get the count for all the items for a tenant grouped by the item status
   * @request GET:/api/v1/admin/item-status-count
   * @secure
   * @response `200` `object`
   */
  itemStatusCountFindAllForAdmin = <T,>(
    query?: {
      itemStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/item-status-count`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingGetForAdminById
   * @summary Get listing details
   * @request GET:/api/v1/admin/listing/{id}
   * @secure
   * @response `200` `object`
   */
  listingGetForAdminById = <T,>(
    id: string,
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
      /**
       * status of the listing
       * @format int32
       */
      status?: number | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/listing/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingUpdate
   * @summary Update an existing active listing.
   * @request PUT:/api/v1/admin/listing/{id}
   * @secure
   * @response `204` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  listingUpdate = (id: string, data: ListingUpdateRequest, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/admin/listing/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingDelete
   * @summary Delete an active listing.
   * @request DELETE:/api/v1/admin/listing/{id}
   * @secure
   * @response `200` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  listingDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/admin/listing/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingWithdraw
   * @summary Withdraw a listing.
   * @request PUT:/api/v1/admin/listing/{id}/withdraw
   * @secure
   * @response `200` `File` Success
   */
  listingWithdraw = (id: string, data: WithdrawListingRequest, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing/${id}/withdraw`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingFindAllForAdmin
   * @summary Get all the listings for the specified tenant
   * @request GET:/api/v1/admin/listing
   * @secure
   * @response `200` `object`
   */
  listingFindAllForAdmin = <T,>(
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
      /** listing type - auction or fixedPrice */
      listingType?: string;
      /**
       * status of the listing
       * @format int32
       */
      status?: number | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/listing`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingUpdateProperties
   * @request PUT:/api/v1/admin/listing
   * @secure
   * @response `200` `File`
   */
  listingUpdateProperties = (data: ListingUpdatePropertiesRequest, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingCreate
   * @summary Create a new listing
   * @request POST:/api/v1/admin/listing
   * @secure
   * @response `200` `object`
   */
  listingCreate = <T,>(data: ListingCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/admin/listing`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingGetForSellerById
   * @summary Get listing details
   * @request GET:/api/v1/seller/listing/{id}
   * @secure
   * @response `200` `object`
   */
  listingGetForSellerById = <T,>(id: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/seller/listing/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingFindAllForSeller
   * @summary Get all the listings for the specified tenant
   * @request GET:/api/v1/seller/listing
   * @secure
   * @response `200` `object`
   */
  listingFindAllForSeller = <T,>(
    query?: {
      /** listing type - auction or fixedPrice */
      listingType?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/seller/listing`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingGetForBuyerById
   * @summary Get listing details
   * @request GET:/api/v1/buyer/listing/{id}
   * @secure
   * @response `200` `object`
   */
  listingGetForBuyerById = <T,>(id: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/buyer/listing/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingFindAllForBuyer
   * @summary Get all the listings for the specified tenant
   * @request GET:/api/v1/buyer/listing
   * @secure
   * @response `200` `object`
   */
  listingFindAllForBuyer = <T,>(
    query?: {
      /** listing type - auction or fixedPrice */
      listingType?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/buyer/listing`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingGetById
   * @summary Get listing details
   * @request GET:/api/v1/listing/{id}
   * @response `200` `object`
   */
  listingGetById = <T,>(id: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/listing/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingWatchOrNot
   * @summary Add logged in user to, or remove from, the list of users.
   * @request PUT:/api/v1/listing/{id}/watch-unwatch
   * @secure
   * @response `200` `File` Success
   */
  listingWatchOrNot = (id: string, data: Body, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/listing/${id}/watch-unwatch`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingFindAll
   * @summary Get all the listings for the specified tenant
   * @request GET:/api/v1/listing
   * @response `200` `object`
   */
  listingFindAll = <T,>(
    query?: {
      /**
       * page number
       * @format int32
       */
      pageNumber?: number | null;
      /**
       * page size
       * @format int32
       */
      pageSize?: number | null;
      /** listing type - auction or fixedPrice */
      listingType?: string;
      /** sort order */
      sortOrder?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/listing`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingMarkFixedPriceAsSold
   * @request PUT:/api/v1/admin/listing/{id}/sold
   * @secure
   * @response `200` `File`
   */
  listingMarkFixedPriceAsSold = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing/${id}/sold`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingMarkFixedPriceAsNotSold
   * @request PUT:/api/v1/admin/listing/{id}/not-sold
   * @secure
   * @response `200` `File`
   */
  listingMarkFixedPriceAsNotSold = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing/${id}/not-sold`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingRequestApproval
   * @summary Request approval for a listing.
   * @request PUT:/api/v1/admin/listing/{id}/request-approval
   * @secure
   * @response `200` `File` Success
   */
  listingRequestApproval = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing/${id}/request-approval`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingAccept
   * @summary Accept listing.
   * @request PUT:/api/v1/admin/listing/{id}/accept
   * @secure
   * @response `200` `File` Success
   */
  listingAccept = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing/${id}/accept`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingReject
   * @summary Reject listing.
   * @request PUT:/api/v1/admin/listing/{id}/reject
   * @secure
   * @response `200` `File` Success
   */
  listingReject = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing/${id}/reject`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingSellerAccept
   * @summary Accept listing.
   * @request PUT:/api/v1/seller/listing/{id}/accept
   * @secure
   * @response `200` `File` Success
   */
  listingSellerAccept = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/seller/listing/${id}/accept`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingSellerRequestEdit
   * @summary Returns a listing back to Draft for additional changes.
   * @request PUT:/api/v1/seller/listing/{id}/request-edit
   * @secure
   * @response `200` `File` Success
   */
  listingSellerRequestEdit = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/seller/listing/${id}/request-edit`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Listing
   * @name ListingComingSoon
   * @summary Move listing to coming soon.
   * @request PUT:/api/v1/admin/listing/{id}/comming-soon
   * @secure
   * @response `200` `File` Success
   */
  listingComingSoon = (id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/listing/${id}/comming-soon`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ListingDetail
   * @name ListingDetailGetById
   * @summary Get listing details, including product and item information
   * @request GET:/api/v1/listing-detail/{id}
   * @response `200` `object`
   */
  listingDetailGetById = <T,>(id: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/listing-detail/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ListingDetail
   * @name ListingDetailFindAllByTenantId
   * @summary Get all the listing details for the specified tenant, including product and item information
   * @request GET:/api/v1/listing-detail
   * @response `200` `object`
   */
  listingDetailFindAllByTenantId = <T,>(
    query?: {
      /** listing type - auction or fixedPrice */
      listingType?: string;
      listingStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/listing-detail`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ListingDetail
   * @name ListingDetailFindAllByTenantIdForAdmin
   * @summary Get all the listing details for the specified tenant, including product and item information
   * @request GET:/api/v1/admin/listing-detail
   * @secure
   * @response `200` `object`
   */
  listingDetailFindAllByTenantIdForAdmin = <T,>(
    query?: {
      /** listing type - auction or fixedPrice */
      listingType?: string;
      listingStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/listing-detail`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ListingDetail
   * @name ListingDetailFindAllForSeller
   * @request GET:/api/v1/seller/listing-detail
   * @secure
   * @response `200` `object`
   */
  listingDetailFindAllForSeller = <T,>(
    query?: {
      listingType?: string;
      listingStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/seller/listing-detail`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ListingDetail
   * @name ListingDetailFindAllForBuyer
   * @request GET:/api/v1/buyer/listing-detail
   * @secure
   * @response `200` `object`
   */
  listingDetailFindAllForBuyer = <T,>(
    query?: {
      listingType?: string;
      listingStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/buyer/listing-detail`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ListingStatusCount
   * @name ListingStatusCountFindAllByTenantId
   * @summary Get the count for all the listings for a tenant grouped by the listing status
   * @request GET:/api/v1/listing-status-count
   * @response `200` `object`
   */
  listingStatusCountFindAllByTenantId = <T,>(
    query?: {
      /** listing type - auction or fixedPrice */
      listingType?: string;
      listingStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/listing-status-count`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ListingStatusCount
   * @name ListingStatusCountFindAllForAdmin
   * @summary Get the count for all the listings for a tenant grouped by the listing status
   * @request GET:/api/v1/admin/listing-status-count
   * @secure
   * @response `200` `object`
   */
  listingStatusCountFindAllForAdmin = <T,>(
    query?: {
      /** listing type - auction or fixedPrice */
      listingType?: string;
      listingStatus?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/listing-status-count`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PaymentMethod
   * @name PaymentMethodGetSetupIntent
   * @summary Get setup intent - 1st step in setting up Stripe payment method for logged in user.
   * @request GET:/api/v1/payment-method/setup-intent
   * @secure
   * @response `200` `object`
   */
  paymentMethodGetSetupIntent = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/payment-method/setup-intent`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PaymentMethod
   * @name PaymentMethodGetPaymentMethodForUser
   * @summary Get payment method for logged in user.
   * @request GET:/api/v1/payment-method
   * @secure
   * @response `200` `object`
   */
  paymentMethodGetPaymentMethodForUser = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/payment-method`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PaymentMethod
   * @name PaymentMethodUpdatePaymentMethodForUser
   * @summary Updated payment method for logged in user.
   * @request PUT:/api/v1/payment-method
   * @secure
   * @response `200` `File` Success
   */
  paymentMethodUpdatePaymentMethodForUser = (data: PaymentMethodRequest, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/payment-method`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PaymentMethod
   * @name PaymentMethodCreatePaymentMethodForUser
   * @summary Add payment method for logged in user.
   * @request POST:/api/v1/payment-method
   * @secure
   * @response `200` `object`
   */
  paymentMethodCreatePaymentMethodForUser = <T,>(data: PaymentMethodRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/payment-method`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PaymentMethod
   * @name PaymentMethodRemovePaymentMethodFromUser
   * @summary Delete payment method from logged in user.
   * @request DELETE:/api/v1/payment-method
   * @secure
   * @response `200` `File` Success
   */
  paymentMethodRemovePaymentMethodFromUser = (params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/payment-method`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassFindProductClasses
   * @summary Only for Dax Admin. Get all product classes
   * @request GET:/api/v1/admin/product-class
   * @secure
   * @response `200` `object`
   */
  productClassFindProductClasses = <T,>(
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/product-class`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassAddProductClass
   * @summary Only for Dax Admin. Create a new product class
   * @request POST:/api/v1/admin/product-class
   * @secure
   * @response `200` `object`
   */
  productClassAddProductClass = <T,>(data: ProductClassCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/admin/product-class`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassGetProductClassWithAssignedTenants
   * @summary Only for Dax Admin. Get product class for specified id with all tenants assigned to it
   * @request GET:/api/v1/admin/product-class/{id}
   * @secure
   * @response `200` `object`
   */
  productClassGetProductClassWithAssignedTenants = <T,>(
    id: string,
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/admin/product-class/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassUpdateProductClass
   * @summary Only for Dax Admin. Update an existing active product class.
   * @request PUT:/api/v1/admin/product-class/{id}
   * @secure
   * @response `204` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  productClassUpdateProductClass = (id: string, data: ProductClassUpdateRequest, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/admin/product-class/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassDeleteProductClass
   * @summary Only for Dax Admin. Delete an existing active product class
   * @request DELETE:/api/v1/admin/product-class/{id}
   * @secure
   * @response `200` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  productClassDeleteProductClass = (id: string, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/api/v1/admin/product-class/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassFindProductClassesByTenantId
   * @summary Get Product Classes for a Tenant
   * @request GET:/api/v1/product-class
   * @response `200` `object`
   */
  productClassFindProductClassesByTenantId = <T,>(
    query: {
      /** whether to include inactive data */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/product-class`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassAssignProductClassToTenant
   * @summary Only for Dax Admin. Assign product classes for specified tenant
   * @request PUT:/api/v1/dax-admin/tenant/{tenantId}/product-class/{id}
   * @secure
   * @response `200` `File` Success
   */
  productClassAssignProductClassToTenant = (tenantId: string, id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/dax-admin/tenant/${tenantId}/product-class/${id}`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductClass
   * @name ProductClassRemoveProductClassFromTenant
   * @summary Only for Dax Admin. Remove product classes from specified tenant
   * @request DELETE:/api/v1/dax-admin/tenant/{tenantId}/product-class/{id}
   * @secure
   * @response `200` `File` Success
   */
  productClassRemoveProductClassFromTenant = (tenantId: string, id: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/dax-admin/tenant/${tenantId}/product-class/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Product
   * @name ProductGetById
   * @summary Get product details
   * @request GET:/api/v1/product/{id}
   * @response `200` `object`
   */
  productGetById = <T,>(id: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/product/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Product
   * @name ProductFindAllByTenantId
   * @summary Get all the products for the specified tenant
   * @request GET:/api/v1/product
   * @response `200` `object`
   */
  productFindAllByTenantId = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/product`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantAdmin
   * @name TenantAdminFindUsers
   * @request POST:/api/v1/admin/user
   * @response `200` `object`
   */
  tenantAdminFindUsers = <T,>(data: FindUsersRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/admin/user`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantAdmin
   * @name TenantAdminGetById
   * @summary Get the User for the specified id
   * @request GET:/api/v1/admin/user/{id}
   * @response `200` `object`
   */
  tenantAdminGetById = <T,>(id: string, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/admin/user/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantAdmin
   * @name TenantAdminRemoveAllRolesFromUser
   * @summary Block user by removing its role(s).
   * @request PUT:/api/v1/admin/user/{userId}/remove-all-roles
   * @response `200` `File` Success
   */
  tenantAdminRemoveAllRolesFromUser = (userId: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/user/${userId}/remove-all-roles`,
      method: "PUT",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantAdmin
   * @name TenantAdminAssignRoleToUser
   * @summary Add role to user.
   * @request PUT:/api/v1/admin/user/{userId}/assign-role
   * @response `200` `File` Success
   */
  tenantAdminAssignRoleToUser = (userId: string, data: TenantUserAssignRoleRequest, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/admin/user/${userId}/assign-role`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags VehicleDetails
   * @name VehicleDetailsGet
   * @summary Get vehicle details
   * @request GET:/api/v1/vehicle/details
   * @response `200` `object`
   */
  vehicleDetailsGet = <T,>(
    query: {
      /** Vehicle registration number */
      regNumber: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/api/v1/vehicle/details`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Webhook
   * @name WebhookProcessedPaymentWebhook
   * @summary Process payment events
   * @request POST:/api/v1/webhook/payment
   * @response `200` `object`
   */
  webhookProcessedPaymentWebhook = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/webhook/payment`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Worker
   * @name WorkerGetWorkersStatuses
   * @summary Get statuses (enabled/disabled) of all the workers.
   * @request GET:/api/v1/dax-admin/worker
   * @response `200` `object`
   */
  workerGetWorkersStatuses = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/api/v1/dax-admin/worker`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Worker
   * @name WorkerManageListingLifeCycleWorkerStatus
   * @request PUT:/api/v1/dax-admin/worker/listing-life-cycle
   * @response `200` `File`
   */
  workerManageListingLifeCycleWorkerStatus = (
    query: {
      status: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/api/v1/dax-admin/worker/listing-life-cycle`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Worker
   * @name WorkerManageProcessingPaymentsWorkerStatus
   * @request PUT:/api/v1/dax-admin/worker/processing-payments
   * @response `200` `File`
   */
  workerManageProcessingPaymentsWorkerStatus = (
    query: {
      status: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/api/v1/dax-admin/worker/processing-payments`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Worker
   * @name WorkerManageEmailWorkerStatus
   * @request PUT:/api/v1/dax-admin/worker/email
   * @response `200` `File`
   */
  workerManageEmailWorkerStatus = (
    query: {
      status: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/api/v1/dax-admin/worker/email`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Worker
   * @name WorkerTesting
   * @request PUT:/api/v1/dax-admin/worker/testing
   * @response `200` `File`
   */
  workerTesting = (params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/api/v1/dax-admin/worker/testing`,
      method: "PUT",
      ...params,
    });
}
